import SectionHeader from '@/components/feature/SectionHeader';
import MovieCard from '@/components/feature/MovieCard';
import { getTrendingMovies } from '@/mocks/movies';

export default function TrendingSection() {
  const trending = getTrendingMovies();

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="热门排行"
          subtitle="全网热播，大家都在看"
          linkTo="/category/movie"
          linkLabel="更多热门"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {trending.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}